import { Directive, TemplateRef } from '@angular/core';
var ToolbarTemplateDirective = (function () {
    function ToolbarTemplateDirective(template) {
        this.template = template;
    }
    return ToolbarTemplateDirective;
}());
export { ToolbarTemplateDirective };
ToolbarTemplateDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ngx-query-toolbar-template]'
            },] },
];
/** @nocollapse */
ToolbarTemplateDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
//# sourceMappingURL=toolbar-template.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/directives/toolbar-template.directive.js
// module id = null
// module chunks = 